// region Url
import { mPipe, pass } from 'fp-utilities';
import { trim } from 'ramda';

declare const _url: unique symbol;

export type Url = string & { [_url]: 'Url' };

export const urlRegex = /^(https?:\/\/)?([\w.-]+\.[a-zA-Z]{2,10})([/?#]\S*)?$/;

export const isUrl = (s: string): s is Url =>
  !!s.match(
    // eslint-disable-next-line no-useless-escape
    urlRegex,
  );

export const fromString = mPipe(trim, pass(isUrl));
// endregion

export function urlfy(s: string): string {
  if (s.startsWith('http://') || s.startsWith('https://')) {
    return s;
  }

  return `https://${s}`;
}
